import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from "../c005-bookingform-common";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
import * as numeral from 'numeral';
import { max } from 'moment';

export class memberPartnerRedeemVoucher {
	private partnerRdmForm:any   = $('.mhvoucher-redeem--vouchers');
	private memberBase:any = new memberPortal();
	private bookingformcommon = new bookingFormCommon();
	$instance:any;
	private voucherList:any;
	private globalList:any;
	private voucherCategory:any;
	private eligibilityFlag:any;
	private initialBal:any;
	private totalVocherRedeemed:any;
	private countryDtls:any;
	private totalVouchersBalance:any;
    private maxVouchCountAll:any;
    private maxVouchCount:any;
	

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
        let defer = $.Deferred();
        let _self = this;
		//let initialBal = 0;
		let channel = $('[data-get-method]').attr('data-get-method');
		//if(channel!=null && channel=="LCP"){
			var queryString = location.search.substring(1);
			var a = queryString.split("&");
			var value1 = a[0];
			var value2 = a[1];
			//alert("value1"+value1+"value2>>>"+value2);
       		$('#'+value2).removeClass("hidden");
			$('#'+value2).removeClass("inactive");
			$('#'+value2).addClass("active");
			$('#'+value2+"_tnc").removeClass("hideclass");
			$('#'+value2+"_tnc").addClass("showclass");
			$('#'+value2+"_redirect").removeClass("hideclass");
			$('#'+value2+"_redirect").addClass("showclass");
		//}

		let cookieAccessToken = _self.getCookie("sapphire");
		var decodedToken = parseJwt(cookieAccessToken);
		let shoppingcartId  = $(".voucher_desp.active a").attr('id');
        //let max_voucher_count = $("#max_voucher_count").val();
        let catlgSearchCode  = $(".voucher_desp.active input:hidden[class='catlgSearchCode']").val();
		let mhVouchLabel  = $(".voucher_desp.active input:hidden[class='mhVouchLabel']").val();
        let voucherCatgry  = $(".voucher_desp.active input:hidden[class='voucherCatgry']").val();
		//alert("max_coucher_count>>"+max_voucher_count);
		var data = {
			'loyaltyToken':	decodedToken.extension_loyaltyToken,
			'enrichId': decodedToken.extension_flyerid,
			'mhVouchLabel': mhVouchLabel,
			'shoppingcartId': shoppingcartId,
			'channel':channel,
			'voucherCatgry':voucherCatgry,
			'selctdCountry':value1,
			'catlgSearchCode':catlgSearchCode
		};
		_self.bookingformcommon.preloader();
		$.ajax({
			type: 'POST',
			url: '/bin/services/new/mhvoucherDtls',
			data: data,
			success: function(data:any){
				//var json = JSON.parse(data);
				let json:any = null;
					if (typeof data === 'string') {
						json = JSON.parse(data);
					}	else {
						json = data;
					}
					_self.bookingformcommon.preloaderClose();
				_self.eligibilityFlag = json.eligibleFlag;
				_self.initialBal = json.currentBalance;
				_self.totalVocherRedeemed = parseInt(json.totalVouchersRedeemed);
				_self.voucherList= json.voucherList;
				_self.voucherCategory= json.voucherCategory;
				_self.totalVouchersBalance=json.totalVouchersBalance;
                _self.maxVouchCountAll=json.maxVouchCount;
				_self.maxVouchCount=json.maxVouchCount;
                var max_voucher_count = _self.maxVouchCount
                 
                for(let a=1;a<=4;a++){
                    $(".incrementer--mhvoucher--redeem--type"+a).attr("data-max",max_voucher_count);
                }
				let redeemBal = _self.partnerRdmForm.find('#mhvoucher-redeem-current-balance');
				if(_self.totalVouchersBalance<max_voucher_count){
					max_voucher_count =  _self.totalVouchersBalance;
				}
				if (_self.eligibilityFlag == "true") {
                   // $("#imgId").attr("src",json.imgId);
                    //$(".title_desp").html(json.title_desc);
                    $("#max_voucher_count").val(json.maxVouchCount);
                    $("#max_voucher_per_transaction").val(json.maxVouchCount);
                    $(".campaignId").val(json.sku);
                    $(".partner_code").val(shoppingcartId);
                    $(".currencyValue").val(json.currencyValue);
                    $("#label--mhvoucher-redeem--type1").text(mhVouchLabel);
                    $("#terms_cond").html(json.terms_cond);
                    $("#how_to_use").html(json.how_to_use);
                    $("#moreInfo").attr("href",json.moreInfo);
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".overwhelming_resp").removeClass("showclass"); 
					$(".overwhelming_resp").addClass("hideclass");
					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("hideclass");//DISPLAY
					$(".partner-redeem-voucher").addClass("showclass");//DISPLAY
					$(".partner-redemption").removeClass("hideclass");//DISPLAY
					$(".partner-redemption").addClass("showclass");//DISPLAY
					$(".partner-redem-incrementer").removeClass("hideclass");//DISPLAY
					$(".partner-redem-incrementer").addClass("showclass");//DISPLAY
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");
					$(".date_expire").removeClass("showclass");
					$(".date_expire").addClass("hideclass");
					if(parseInt(_self.initialBal)<=0)
					{
						$(".overwhelming_resp").removeClass("showclass"); 
						$(".overwhelming_resp").addClass("hideclass");
						$(".maxcount_reached_onload").removeClass("showclass");
						$(".maxcount_reached_onload").addClass("hideclass");
						$(".maxcount_reached_onclick").removeClass("showclass"); 
						$(".maxcount_reached_onclick").addClass("hideclass"); 
						//$('.voucherEligibity').text("Sorry, you have insufficient MILES points for the redemption.");
						$(".voucherEligibity").removeClass("hideclass"); //DISPLAY
						$(".voucherEligibity").addClass("showclass"); //DISPLAY
						$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
						$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
						$(".partner-redemption").removeClass("hideclass");
						$(".partner-redemption").addClass("showclass");
						$(".partner-redem-incrementer").removeClass("hideclass");
						$(".partner-redem-incrementer").addClass("showclass");
					}
					for(let i=1;i<=_self.voucherList.length;i++)
					{
						document.getElementById("label--mhvoucher-redeem--type"+i).innerHTML = json.voucherList[i-1].AwardKey;
						let voucherCountVal=parseInt(json.voucherList[i-1].AwardCount);
						if(voucherCountVal==0){
							if(!$("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee"))
							{
								$("#mhvoucher--redeem--type"+i+"--increment").addClass("disablee");
							}
						}
						//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
						//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
						$("#mhVochdispClass"+i).removeClass("hideclass");
						$("#mhVochdispClass"+i).addClass("showclass");
					}
					redeemBal.html(json.currentBalance);
					//_self.setRedeemVoucherDtls(json);
					_self.getVoucherTypeValues(_self.initialBal,_self.voucherList,0,max_voucher_count,_self.totalVouchersBalance);
				}
				else if(_self.eligibilityFlag == "false")
				{
					redeemBal.html(json.currentBalance);
					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".overwhelming_resp").removeClass("hideclass"); //DISPLAY
					$(".overwhelming_resp").addClass("showclass"); //DISPLAY
					//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
					$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
					$(".partner-redemption").removeClass("hideclass");
					$(".partner-redemption").addClass("showclass");
					$(".partner-redem-incrementer").removeClass("hideclass");
					$(".partner-redem-incrementer").addClass("showclass");
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					//$(".max4errorMsg").removeClass("showclass");
					//$(".max4errorMsg").addClass("hideclass");
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");
					$(".date_expire").removeClass("showclass");
					$(".date_expire").addClass("hideclass");
					for(let i=1;i<=_self.voucherList.length;i++)
					{
						document.getElementById("label--mhvoucher-redeem--type"+i).innerHTML = json.voucherList[i-1].AwardKey;
						//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
						//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
						$("#mhVochdispClass"+i).removeClass("hideclass");
						$("#mhVochdispClass"+i).addClass("showclass");
					}
					for(let a=1;a<=4;a++)
						{
							if(!$("#mhvoucher--redeem--type"+a+"--increment").hasClass("disablee"))
							{
								$("#mhvoucher--redeem--type"+a+"--increment").addClass("disablee");
							}
						}
				}else if(_self.eligibilityFlag == "DateError"){

					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".overwhelming_resp").removeClass("showclass"); 
					$(".overwhelming_resp").addClass("hideclass"); 
					//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
					$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
					$(".partner-redemption").removeClass("hideclass");//DISPLAY
					$(".partner-redemption").addClass("showclass"); //DISPLAY
					$(".partner-redem-incrementer").removeClass("hideclass"); //DISPLAY
					$(".partner-redem-incrementer").addClass("showclass"); //DISPLAY
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					$(".date_expire").removeClass("hideclass");//DISPLAY
					$(".date_expire").addClass("showclass");//DISPLAY
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");
					for(let i=1;i<=_self.voucherList.length;i++)
					{
						document.getElementById("label--mhvoucher-redeem--type"+i).innerHTML = json.voucherList[i-1].AwardKey;
						//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
						//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
						$("#mhVochdispClass"+i).removeClass("hideclass");
						$("#mhVochdispClass"+i).addClass("showclass");
					}
					for(let a=1;a<=4;a++)
						{
							if(!$("#mhvoucher--redeem--type"+a+"--increment").hasClass("disablee"))
							{
								$("#mhvoucher--redeem--type"+a+"--increment").addClass("disablee");
							}
						}

				}else{

					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".overwhelming_resp").removeClass("showclass"); //DISPLAY
					$(".overwhelming_resp").addClass("hideclass"); //DISPLAY
					//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("showclass"); //DISPLAY
					$(".partner-redeem-voucher").addClass("hideclass"); //DISPLAY
					$(".partner-redemption").removeClass("showclass");
					$(".partner-redemption").addClass("hideclass");
					$(".partner-redem-incrementer").removeClass("showclass");
					$(".partner-redem-incrementer").addClass("hideclass");
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".onload_errorMsg").removeClass("hideclass");//DISPLAY
					$(".onload_errorMsg").addClass("showclass");//DISPLAY
					$(".date_expire").removeClass("showclass");//DISPLAY
					$(".date_expire").addClass("hideclass");//DISPLAY
					//$(".max4errorMsg").removeClass("showclass");
					//$(".max4errorMsg").addClass("hideclass");
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");

				}
				defer.resolve(json);			
			}, error: function(error: any) {
				
				_self.bookingformcommon.preloaderClose();
				defer.reject(error);
			}
		});
		return defer.promise();
	
	function parseJwt (token:any): any {
		var base64Url = token.split('.')[1];
		var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	
		return JSON.parse(base64);
	};
}

getCookie(name:string): any {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	var cookieVal:any;
	if (parts.length == 2) {
		cookieVal = parts.pop().split(";").shift();
		return cookieVal;
	}
}
	initSelectizeInputs(): any {
		let _self = this;
		let totalInput      = _self.partnerRdmForm.find('#mhvoucher-redeem--total');
		let incremeterInput = _self.partnerRdmForm.find('.partner-redeem--voucher-to-use');
		let defer = $.Deferred();
		
		// when incrementer value changes
		incremeterInput.on('incrementer.changed', function(e:any, val:any){
			let selectedVoucher=e.target.id;
			console.log(e);
			let rm50TotMiles = 0;
			let rm100TotMiles = 0;
			let rm150TotMiles = 0;
			let rm200TotMiles = 0;
			let totMilesValue = 0;
			let currentBalVal = 0;
			let voucherUnit = 0;
			let voucherUnit1 = 0;
			let voucherUnit2 = 0;
			let voucherUnit3 = 0;
			let voucherUnit4 = 0;
			let rm50Voucher=0;
			let rm100Voucher=0;
			let rm150Voucher=0;
			let rm200Voucher=0;
			let rmCount1=0;
			let rmCount2=0;
			let rmCount3=0;
			let rmCount4=0;
			let voucherUnitCount = 0;
			let firstIndex = 0;
			let totVocherRedemed=0;
			let redemBalValues=0;
			let totVal =0;
			let totalVouchersBalance=0;
			// let max_voucher_count_all=0;
			let redeemBalance       = _self.partnerRdmForm.find('#mhvoucher-redeem-current-balance').text();
			var shoppingCartActive  = $(".voucher_desp.active a").attr('id');
            //let max_voucher_count = $("#max_voucher_count").val();
            var max_voucher_count_all = $(".voucher_desp.active input:hidden[class='max_voucher_count']").val();
			var max_voucher_count_on_inc = $(".voucher_desp.active input:hidden[class='max_voucher_per_transaction']").val();
						var eligibilityFlag = _self.eligibilityFlag;
						 firstIndex = parseInt(_self.initialBal);
						totVocherRedemed = 0;//parseInt(_self.totalVocherRedeemed);
						totalVouchersBalance=parseInt(_self.totalVouchersBalance);
						max_voucher_count_on_inc = totalVouchersBalance<max_voucher_count_on_inc? totalVouchersBalance:max_voucher_count_on_inc;
						let voucherListIncr= _self.voucherList;
						var redeemBal = _self.partnerRdmForm.find( '#mhvoucher-redeem-current-balance').text();
						if (eligibilityFlag == "true") {
							//getIncreamentVoucherDtls(json);
							for(let i=1;i<=voucherListIncr.length;i++)
							{
								let countVoucher=_self.partnerRdmForm.find('#mhvoucher--redeem--type'+i+'input').val();
								let countVal=0;
								if(countVoucher!=""){
									countVal=parseInt(countVoucher);
									if(i==1){
										voucherUnit1=countVal;
										rm50Voucher=parseInt(voucherListIncr[i-1].AwardValue);
										rmCount1=parseInt(voucherListIncr[i-1].AwardCount);
									}else if(i==2){
										voucherUnit2=countVal;
										rm100Voucher=parseInt(voucherListIncr[i-1].AwardValue);
										rmCount2=parseInt(voucherListIncr[i-1].AwardCount);
									}else if(i==3){
										voucherUnit3=countVal;
										rm150Voucher=parseInt(voucherListIncr[i-1].AwardValue);
										rmCount3=parseInt(voucherListIncr[i-1].AwardCount);
									}else if(i==4){
										voucherUnit4=countVal;
										rm200Voucher=parseInt(voucherListIncr[i-1].AwardValue);
										rmCount4=parseInt(voucherListIncr[i-1].AwardCount);
									}
								}
								voucherUnitCount=voucherUnitCount+countVal;
							}
							if(totVocherRedemed>0)
							{
								voucherUnitCount=totVocherRedemed+voucherUnitCount;
							}else
							{
								voucherUnitCount=voucherUnitCount-totVocherRedemed;
							}
							//voucherUnit = parseInt(val);
							if(voucherUnitCount<=parseInt(max_voucher_count_on_inc)){
								if(voucherUnit1<=rmCount1){
									if(rm50Voucher>0){
										rm50TotMiles = voucherUnit1 * rm50Voucher;
									}
								}
								if(voucherUnit2<=rmCount2){
									if(rm100Voucher>0){
										rm100TotMiles = voucherUnit2 * rm100Voucher;
									}
								}
								if(voucherUnit3<=rmCount3){
									if(rm150Voucher>0){
										rm150TotMiles = voucherUnit3 * rm150Voucher;
									}
								}
								if(voucherUnit4<=rmCount4){
									if(rm200Voucher>0){
										rm200TotMiles = voucherUnit4 * rm200Voucher;
									}
								}
								totMilesValue=rm50TotMiles+rm100TotMiles+rm150TotMiles+rm200TotMiles;
								console.log(voucherUnit1, totMilesValue);
								totalInput.val(totMilesValue);
								 redemBalValues  = parseInt(redeemBalance);
								 totVal          = parseInt(totalInput.val());
								currentBalVal=redemBalValues-totVal;
								_self.getVoucherTypeValues(currentBalVal,voucherListIncr,voucherUnitCount,max_voucher_count_on_inc,totalVouchersBalance);
								if(totVal>0)
								{	//Perform terms and conditions check for qwikcilver and lifestyle vouchers vouchers only
									//if(_self.voucherCategory=='qc_voucher' || _self.voucherCategory=='lifestyle_voucher'){
										if($('#redemption--miles-terms-and-conditions').is(':checked')){
											$(".btn-member--submit").removeClass("disablee");
										}
									/*}else{
										$(".btn-member--submit").removeClass("disablee");
									}*/
								}else{
									$(".btn-member--submit").addClass("disablee");
								}
								/*if(voucherUnitCount==4){
									for(let j=1;j<=voucherListIncr.length;j++){
										if($("#partner-redeem--voucher-type"+j+"--increment").hasClass("disablee")){
										}else{
											$("#partner-redeem--voucher-type"+j+"--increment").addClass("disablee");
										}
									}
								}*/
							}
						}else{
							for(let k=1;k<=voucherListIncr.length;k++){
								if($("#mhvoucher--redeem--type"+k+"--increment").hasClass("disablee")){
								}else{
									$("#mhvoucher--redeem--type"+k+"--increment").addClass("disablee");
								}
							}					
						}

		});
	}
	/**
	 * [initIncrementer description]
	 * @return {any} [description]
	 */
	initIncrementer(): any {
		
		let _self = this;
		let inputElArr:any = $.makeArray(_self.partnerRdmForm.find('.incrementer'));
		_self.setIntialIncreamentVal(inputElArr,"N");
		//_self.memberBase.initIncrementer(inputElArr);
	}
	
	getVoucherTypeValues(curVal:any,voucherList:any,totalVoucherRedeemed:any,max_voucher_count:any,totalVouchersBalance:any):any{
	
		let _self = this;
		let rmcode1:any;
		let rmcodeValue1=0;
		let rmcode2:any;
		let rmcodeValue2=0;
		let rmcode3:any;
		let rmcodeValue3=0;
		let rmcode4:any;
		let rmcodeValue4=0;
		let rmcodeCount1=0;
		let rmcodeCount2=0;
		let rmcodeCount3=0;
		let rmcodeCount4=0;
		let rmVoucherUnit1=0;
		let rmVoucherUnit2=0;
		let rmVoucherUnit3=0;
		let rmVoucherUnit4=0;
		let totalCountVouchers=0;
		let onLoadVoucherCount=0;
		let max_voucher_count_now=0;
		if(voucherList!=null && voucherList.length>0){
			for(let a=1;a<=voucherList.length;a++){
				let countVoucher=_self.partnerRdmForm.find('#mhvoucher--redeem--type'+a+'input').val();
				if(countVoucher!=""){
					onLoadVoucherCount=parseInt(countVoucher);
					totalCountVouchers=totalCountVouchers+onLoadVoucherCount;
				}
			}
			for(let i=1;i<=voucherList.length;i++){
				//window['rmcode'+i] = data.eligibilityBean.voucherList[i].AwardCode;
				//window['rmcodeValue'+i] = data.eligibilityBean.voucherList[i].AwardValue;
				let voucherCount=$("#mhvoucher--redeem--type"+i+"input").val();
				
				let valCount=0;
				if(i==1){
					rmcode1 = voucherList[i-1].AwardKey;
					rmcodeValue1 = parseInt(voucherList[i-1].AwardValue);
					rmcodeCount1 = parseInt(voucherList[i-1].AwardCount);
					if(voucherCount!=""){
						valCount=parseInt(voucherCount);
						rmVoucherUnit1=valCount;
					}
				}
				if(i==2)
				{
					rmcode2 =voucherList[i-1].AwardKey;
					rmcodeValue2 = parseInt(voucherList[i-1].AwardValue);
					rmcodeCount2 = parseInt(voucherList[i-1].AwardCount);
					if(voucherCount!=""){
						valCount=parseInt(voucherCount);
						rmVoucherUnit2=valCount;
					}
				}
				if(i==3)
				{
					rmcode3 = voucherList[i-1].AwardKey;
					rmcodeValue3 = parseInt(voucherList[i-1].AwardValue);
					rmcodeCount3 = parseInt(voucherList[i-1].AwardCount);
					if(voucherCount!=""){
						valCount=parseInt(voucherCount);
						rmVoucherUnit3=valCount;
					}
				}
				if(i==4)
				{
					rmcode4 = voucherList[i-1].AwardKey;
					rmcodeValue4 = parseInt(voucherList[i-1].AwardValue);
					rmcodeCount4 = parseInt(voucherList[i-1].AwardCount);
					if(voucherCount!=""){
						valCount=parseInt(voucherCount);
						rmVoucherUnit4=valCount;
					}
				}
			}
			if(rmcodeCount1>=parseInt(max_voucher_count))
			{
				rmcodeCount1=parseInt(max_voucher_count)
			}
			if(rmcodeCount2>=parseInt(max_voucher_count))
			{
				rmcodeCount2=parseInt(max_voucher_count)
			}
			if(rmcodeCount3>=parseInt(max_voucher_count))
			{
				rmcodeCount3=parseInt(max_voucher_count)
			}
			if(rmcodeCount4>=parseInt(max_voucher_count))
			{
				rmcodeCount4=parseInt(max_voucher_count)
			}

            // if(totalVouchersBalance<parseInt(max_voucher_count)){
		
			// 	for(let i=1;i<=voucherList.length;i++){
			// 		if(i==totalVouchersBalance){
			// 			if(!$("#partner-redeem--voucher-type"+i+"--increment").hasClass("disablee")){
			// 				$("#partner-redeem--voucher-type"+i+"--increment").addClass("disablee");
			// 				$(".maxcountall_reached_onclick").removeClass("hideclass");
			// 				$(".maxcountall_reached_onclick").addClass("showclass"); //DISPLAY
			// 			}
						
			// 		}
			// 		else{
			// 			$("#partner-redeem--voucher-type"+i+"--increment").removeClass("disablee");
			// 			$(".maxcountall_reached_onclick").addClass("hideclass");
			// 			$(".maxcountall_reached_onclick").removeClass("showclass"); //DISPLAY
			// 		}
			// 	}
			// }

			// else 
			
			// if(totalVouchersBalance>0){
			if(totalVoucherRedeemed<parseInt(max_voucher_count)){

				if(curVal>=rmcodeValue1){

					if(rmcodeValue4>0){
						if(curVal>=rmcodeValue4){
							if(rmVoucherUnit4<rmcodeCount4){
								for(let i=1;i<=voucherList.length;i++){
									if($("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
										$("#mhvoucher--redeem--type"+i+"--increment").removeClass("disablee");
									}
								}
								$(".rmMaxErrorMsg4").removeClass("showclass");
								$(".rmMaxErrorMsg4").addClass("hideclass");
							}else{
								for(let i=1;i<=voucherList.length;i++){
									if(i==4){
										if(!$("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
											$("#mhvoucher--redeem--type"+i+"--increment").addClass("disablee");
										}
									}
								}
								//if(rmcodeCount4>0){
									//$('.rmMaxErrorMsg4').text("Sorry, RM"+rmcode4+" vouchers quota has been completed or exceeded maximum.");
									//$('.rmMaxErrorMsg4').text("Thank you for your patronage. Currently there is no more available RM"+rmcode4+" vouchers for redemption. You will be pleased to know that we have more in store in time to come. Please visit us again.");
									$(".rmMaxErrorMsg4").removeClass("hideclass");
									$(".rmMaxErrorMsg4").addClass("showclass");
								//}
								
							}
						}else{
							for(let i=1;i<=voucherList.length;i++){
								if(i==4)
								{
									if(!$("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
										$("#mhvoucher--redeem--type"+i+"--increment").addClass("disablee");
									}
								}
							}
						}
					}

					if(rmcodeValue3>0){
						if(curVal>=rmcodeValue3){
							if(rmVoucherUnit3<rmcodeCount3){	
								for(let i=1;i<=voucherList.length;i++){
									if(i==1||i==2||i==3){
										if($("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
											$("#mhvoucher--redeem--type"+i+"--increment").removeClass("disablee");
										}
									}
								}
								$(".rmMaxErrorMsg3").removeClass("showclass");
								$(".rmMaxErrorMsg3").addClass("hideclass");
							}else{
								for(let i=1;i<=voucherList.length;i++){
									if(i==3){
										if(!$("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
											$("#mhvoucher--redeem--type"+i+"--increment").addClass("disablee");
										}
									}
								}
								//if(rmcodeCount3>0){
									//$('.rmMaxErrorMsg3').text("Thank you for your patronage. Currently there is no more available RM"+rmcode3+" vouchers for redemption. You will be pleased to know that we have more in store in time to come. Please visit us again.");
									$(".rmMaxErrorMsg3").removeClass("hideclass");
									$(".rmMaxErrorMsg3").addClass("showclass");
								//}
								
							}			
						}else{
							for(let i=1;i<=voucherList.length;i++){
								if(i==3)
								{
									if(!$("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
										$("#mhvoucher--redeem--type"+i+"--increment").addClass("disablee");
									}
								}
							}
						}				
					}	
					if(rmcodeValue2>0){
						if(curVal>=rmcodeValue2){
							if(rmVoucherUnit2<rmcodeCount2){	
								for(let i=1;i<=voucherList.length;i++){
									if(i==1 || i==2){
										if($("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
											$("#mhvoucher--redeem--type"+i+"--increment").removeClass("disablee");
										}
									}
								}
								$(".rmMaxErrorMsg2").removeClass("showclass");
								$(".rmMaxErrorMsg2").addClass("hideclass");
							}else{
								for(let i=1;i<=voucherList.length;i++){
									if(i==2){
										if(!$("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
											$("#mhvoucher--redeem--type"+i+"--increment").addClass("disablee");
										}
									}
								}
								//if(rmcodeCount2>0){
									//$('.rmMaxErrorMsg2').text("Thank you for your patronage. Currently there is no more available RM"+rmcode2+" vouchers for redemption. You will be pleased to know that we have more in store in time to come. Please visit us again.");
									$(".rmMaxErrorMsg2").removeClass("hideclass");
									$(".rmMaxErrorMsg2").addClass("showclass");
								//}
								
							}
						}else{
							for(let i=1;i<=voucherList.length;i++){
								if(i==2)
								{
									if(!$("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
										$("#mhvoucher--redeem--type"+i+"--increment").addClass("disablee");
									}
								}
							}
						}
					}	
					if(rmcodeValue1>0){
						if(curVal>=rmcodeValue1){
							if(rmVoucherUnit1<rmcodeCount1){	
								for(let i=1;i<=voucherList.length;i++){
									if(i==1){
										if($("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
										$("#mhvoucher--redeem--type"+i+"--increment").removeClass("disablee");
										}
									}
								}
								$(".rmMaxErrorMsg1").removeClass("showclass");
								$(".rmMaxErrorMsg1").addClass("hideclass");
							}else{
								for(let i=1;i<=voucherList.length;i++){
									if(i==1){
										if(!$("#mhvoucher--redeem--type"+i+"--increment").hasClass("disablee")){
											$("#mhvoucher--redeem--type"+i+"--increment").addClass("disablee");
										}
									}
								}
								//if(rmcodeCount1>0){
									//$('.rmMaxErrorMsg1').text("Thank you for your patronage. Currently there is no more available RM"+rmcode1+" vouchers for redemption. You will be pleased to know that we have more in store in time to come. Please visit us again.");
									$(".rmMaxErrorMsg1").removeClass("hideclass");
									$(".rmMaxErrorMsg1").addClass("showclass");
								//}
								
							}
						}else{	
							for(let a=1;a<=voucherList.length;a++){
								if(!$("#mhvoucher--redeem--type"+a+"--increment").hasClass("disablee")){
									$("#mhvoucher--redeem--type"+a+"--increment").addClass("disablee");
								}
							}	
						}
					}
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass");
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".maxcountall_reached_onclick").removeClass("showclass");
					$(".maxcountall_reached_onclick").addClass("hideclass");
					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".overwhelming_resp").removeClass("showclass"); 
					$(".overwhelming_resp").addClass("hideclass");
				}
				else{
					for(let a=1;a<=voucherList.length;a++){
						if($("#mhvoucher--redeem--type"+a+"--increment").hasClass("disablee")){
						}else{
							$("#mhvoucher--redeem--type"+a+"--increment").addClass("disablee");
						}
					}
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("hideclass");
					$(".partner-redeem-voucher").addClass("showclass");
					//$(".max4errorMsg").removeClass("showclass");
					//$(".max4errorMsg").addClass("hideclass");
					//alert("totalCountVouchers>>"+totalCountVouchers);
					if(totalCountVouchers<=0)
					{
						//$('.voucherEligibity').text("Sorry, you have insufficient MILES points for the redemption.");
						$(".voucherEligibity").removeClass("hideclass");
						$(".voucherEligibity").addClass("showclass");
					}else{
						$(".voucherEligibity").removeClass("showclass");
						$(".voucherEligibity").addClass("hideclass");
					}
					$(".overwhelming_resp").removeClass("showclass"); 
					$(".overwhelming_resp").addClass("hideclass");
					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".maxcountall_reached_onclick").removeClass("showclass");
					$(".maxcountall_reached_onclick").addClass("hideclass");
					

					$(".btn-member--submit").addClass("disablee");
					
				}
			}else{
					for(let a=1;a<=voucherList.length;a++){
						if($("#mhvoucher--redeem--type"+a+"--increment").hasClass("disablee")){
						}else{
							$("#mhvoucher--redeem--type"+a+"--increment").addClass("disablee");
						}
					}
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("hideclass");
					$(".partner-redeem-voucher").addClass("showclass");
					
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					
					if(totalCountVouchers<=0)
					{
						$(".maxcount_reached_onload").removeClass("hideclass");
						$(".maxcount_reached_onload").addClass("showclass"); //DISPLAY
						$(".maxcount_reached_onclick").removeClass("showclass"); 
					    $(".maxcount_reached_onclick").addClass("hideclass");
						$(".maxcountall_reached_onclick").removeClass("showclass");
						$(".maxcountall_reached_onclick").addClass("hideclass");
						//$('.voucherEligibity').text("Thanks for your patronage. You have redeemed the allowable number of vouchers for this campaign.  You will be pleased to know that we have more in store in time to come. Do get your miles ready for the next exciting redemption offer. Thanks.");
					}
			
					else if(totalVouchersBalance<parseInt(max_voucher_count)){
						$(".maxcountall_reached_onclick").removeClass("hideclass");
						$(".maxcountall_reached_onclick").addClass("showclass"); //DISPLAY
						$(".maxcount_reached_onclick").removeClass("showclass"); 
					    $(".maxcount_reached_onclick").addClass("hideclass");
						$(".maxcount_reached_onload").removeClass("showclass");
						$(".maxcount_reached_onload").addClass("hideclass");
					}
					else{
						if(totalVouchersBalance==parseInt(max_voucher_count)){
							// overall voucher limit has been reached
							$(".maxcountall_reached_onclick").removeClass("hideclass");
							$(".maxcountall_reached_onclick").addClass("showclass"); //DISPLAY
							$(".maxcount_reached_onclick").removeClass("showclass"); 
					    	$(".maxcount_reached_onclick").addClass("hideclass");
						}else{
							// per transaction limit has been reached
							$(".maxcount_reached_onclick").removeClass("hideclass");
							$(".maxcount_reached_onclick").addClass("showclass"); //DISPLAY
							$(".maxcountall_reached_onclick").removeClass("showclass");
							$(".maxcountall_reached_onclick").addClass("hideclass");
						}
			
						$(".maxcount_reached_onload").removeClass("showclass");
						$(".maxcount_reached_onload").addClass("hideclass");
					}
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass"); //DISPLAY
					$(".overwhelming_resp").removeClass("showclass"); 
					$(".overwhelming_resp").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");
				}		    		
		}else{
			$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
			$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
			$(".maxcount_reached_onclick").removeClass("showclass");
			$(".maxcount_reached_onclick").addClass("hideclass");
			$(".maxcountall_reached_onclick").removeClass("showclass");
			$(".maxcountall_reached_onclick").addClass("hideclass");
			$(".maxcount_reached_onload").removeClass("showclass");
			$(".maxcount_reached_onload").addClass("hideclass");
			$(".overwhelming_resp").removeClass("showclass"); 
			$(".overwhelming_resp").addClass("hideclass");
			//$('.voucherEligibity').text("Sorry, you have insufficient MILES points for the redemption.");
			$(".voucherEligibity").removeClass("hideclass"); //DISPLAY
			$(".voucherEligibity").addClass("showclass"); //DISPLAY
			$(".partner-redeem--voucher-to-use").removeClass("showclass");
			$(".partner-redeem--voucher-to-use").addClass("hideclass");
			$(".partner-redemption").removeClass("showclass");
			$(".partner-redemption").addClass("hideclass");
			$(".partner-redem-incrementer").removeClass("showclass");
			$(".partner-redem-incrementer").addClass("hideclass");
		}	
	}
	setIntialIncreamentVal(inputElArr:any,cartId:any): any{	
		let _self=this;
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let el = $(inputElArr[i]);
			let btnMinus       = el.find('.incrementer__btn.incrementer--decrement');
			let btnPlus        = el.find('.incrementer__btn.incrementer--increment');
			let elDisplay      = el.find('.incrementer__display');
			let input          = el.find('input[type="hidden"]');
			let curVal:number = 0;
			let	params = {
				'min': parseInt(el[0].dataset.min),
				'max': parseInt(el[0].dataset.max),
				'initvalue': parseInt(el[0].dataset.initValue)
			};
			if(_self.voucherCategory=='qc_voucher'){
				curVal=0;
				elDisplay.html(curVal);
				input.val(curVal);
				input.parent().trigger('incrementer.changed', [curVal]);
			}
			// btnMinus click handler
			// - on click, increment display value & input[hidden] value
			btnMinus.on('click', function(e:any) {
				e.preventDefault();
				e.stopPropagation();
				cartId="N";
				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(25);
				}
				curVal = setIncrementer(elDisplay, input, curVal, params, 'decrement');
				//alert("on decrement>>"+curVal);
			});

			// btnMinus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnMinInterval:any;

			btnMinus.on('mousedown', function(e:any) {
				e.preventDefault();
				e.stopPropagation();
				cartId="N";
				btnMinInterval = setInterval(function() {
					curVal = setIncrementer(elDisplay, input, curVal, params, 'decrement');
				}, 200);
			}).on('mouseup mouseleave', function() {
				clearInterval(btnMinInterval);
			});

			// btnPlus click handler
			// - on click, increment display value & input[hidden] value
			btnPlus.on('click', function(e:any) {
				e.preventDefault();
				e.stopPropagation();
				cartId="N";
				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(35);
				}
				curVal = setIncrementer(elDisplay, input, curVal, params, 'increment');
				//alert("on increment>>"+curVal);
			});

			// btnPlus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnPlusInterval:any;
			btnPlus.on('mousedown', function(e:any) {
				e.preventDefault();
				e.stopPropagation();
				cartId="N";
				// set initial delay (500ms)
				btnPlusInterval = setInterval(function() {
					curVal = setIncrementer(elDisplay, input, curVal, params, 'increment');
				}, 200);
			}).on('mouseup mouseleave', function() {
				clearInterval(btnPlusInterval);
			});
			if(cartId=="Y")
			{
				if(i<len){
					curVal = setIncrementer(elDisplay, input, 0, params, 'inc');
				}else{
					cartId="N";
				}
				
			}
		}

		/**
		 * common function to set incrementer value/display for click/hold events
		 * @param  {any}    elDisplay [description]
		 * @param  {any}    input     [description]
		 * @param  {any}    curVal    [description]
		 * @param  {any}    params    [description]
		 * @param  {string} type      [description]
		 * @return {any}              [description]
		 */
		function setIncrementer(elDisplay:any, input:any, curVal:any, params:any, type:string,):any {
			if (type == 'decrement') {				
				if (curVal > params.min) {
					curVal--;
				}
			}

			if (type == 'increment') {
					if (curVal < params.max) {
						curVal++;
					}
			}
			if (curVal <= params.min){

                $("#mhvoucher--redeem--type"+i+"--decrement").addClass("incrementer--decrement");

            }
			else{

                $("#mhvoucher--redeem--type"+i+"--decrement").removeClass("incrementer--decrement");

            }
			//alert("assign-curVal>>"+curVal);
			if(cartId=="Y"){
				curVal=0;
				elDisplay.html(curVal);
				input.val(curVal);
			}else{
				elDisplay.html(curVal);
				input.val(curVal);
				cartId="N";
			}
			input.parent().trigger('incrementer.changed', [curVal]);
			return curVal;
		}
	}
	initSubmitForm(): any {
		let _self = this;
		$("#mhvouchers-confirmation-popup").on('click', '.msg-btn-confirm', function() {
			$.magnificPopup.close();
			_self.submissionAPI();
		});

		$("#mhvouchers-confirmation-popup").on('click', '.msg-btn-cancel', function() {
			$.magnificPopup.close();
		});
		$(".btn-member--submit").click(function() {

				$("#mhvouchers-confirmation-popup #total-enrich-points").val(_self.partnerRdmForm.find('#mhvoucher-redeem--total').val())
				$("#mhvouchers-confirmation-popup #total-qty-redeemed").val(_self.partnerRdmForm.find('#mhvoucher--redeem--type1').text().trim())
				
				$.magnificPopup.open({
					items: {
						src: '#mhvouchers-confirmation-popup'
				},
				type: 'inline',
				midClick: true,
				enableEscapeKey: false,
				showCloseBtn: false,
				closeOnBgClick: false,
				modal: true,
		 
			}, 0);
			

		});
	}

	submissionAPI():any{
		let defer = $.Deferred();
		let _self = this;
		let awardcode1:any;
			let awardcode2:any;
			let awardcode3:any;
			let awardcode4:any;
			let awardValue1:any;
			if(_self.voucherList.length>0){
				for(let k=0;k<=_self.voucherList.length-1;k++){
					if(k==0){
						awardcode1 = _self.voucherList[k].AwardCode;
						awardValue1=_self.voucherList[k].AwardValue;
					}
					if(k==1)
					{
						awardcode2 =_self.voucherList[k].AwardCode;
					}
					if(k==2)
					{
						awardcode3 = _self.voucherList[k].AwardCode;
					}
					if(k==3)
					{
						awardcode4 = _self.voucherList[k].AwardCode;
					}
				}
			}
			let initialBalance = _self.partnerRdmForm.find('#mhvoucher-redeem-current-balance').text();
			let totalRedeemPoints= _self.partnerRdmForm.find('#mhvoucher-redeem--total').val();
			//let discountAmount1=_self.partnerRdmForm.find('#label--partner-redeem--voucher-type1').text().replace('RM','').trim();
			let discountAmount1=_self.partnerRdmForm.find('#label--mhvoucher-redeem--type1').text().trim();
			let discountAmount1Count=_self.partnerRdmForm.find('#mhvoucher--redeem--type1').text().trim();
			//alert("awardcode"+_self.partnerRdmForm.find('#awardcode_input1').val());
			//let awardcode1=_self.partnerRdmForm.find('#awardcode_input1').val();
			//alert("awardcode1>>"+awardcode1);
			let shoppingcartId  = $(".voucher_desp.active a").attr('id');
			let catlgSearchCode  = $(".voucher_desp.active input:hidden[class='catlgSearchCode']").val();
			let mhVouchLabel  = $(".voucher_desp.active input:hidden[class='mhVouchLabel']").val();
			let voucherCatg	  = $(".voucher_desp.active input:hidden[class='voucherCatgry']").val();
			let currencyValue	  = $(".voucher_desp.active input:hidden[class='currencyValue']").val();
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Redemption Page - Catalogue Item PDP ',
                'clickName': 'click:btn-click:catalogue-redemption-submit',
                'componentType': 'btn',
                'componentName': 'Redemption Submit Button',
                'componentID': '',
				'attributes': [
					{
						'key': 'catalogue-redemption-submit',
						'value': totalRedeemPoints+':'+discountAmount1Count
					}
				] 
            });
			if(parseInt(totalRedeemPoints)<=0)
			{
				$(".successMsg").removeClass("showclass");
				$(".successMsg").addClass("hideclass");
				$(".errorMsg").removeClass("showclass");
				$(".errorMsg").addClass("hideclass");
				$(".onload_errorMsg").removeClass("showclass");
				$(".onload_errorMsg").addClass("hideclass");
				$(".partner-redeem-voucher").removeClass("hideclass");
				$(".partner-redeem-voucher").addClass("showclass");
				$(".overwhelming_resp").removeClass("showclass"); 
				$(".overwhelming_resp").addClass("hideclass");
				$(".maxcount_reached_onload").removeClass("showclass"); 
				$(".maxcount_reached_onload").addClass("hideclass");
				$(".maxcount_reached_onclick").removeClass("showclass"); 
				$(".maxcount_reached_onclick").addClass("hideclass");
				$(".maxcountall_reached_onclick").removeClass("showclass");
				$(".maxcountall_reached_onclick").addClass("hideclass");
				//$('.voucherEligibity').text("Sorry, you have insufficient MILES points for the redemption.");
				$(".voucherEligibity").removeClass("hideclass");
				$(".voucherEligibity").addClass("showclass");
				//$(".max4errorMsg").removeClass("showclass");
				//$(".max4errorMsg").addClass("hideclass");
			}else{
				let channel = $('[data-get-method]').attr('data-get-method');
				let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'sku':catlgSearchCode,
					'mhVouchLabel':mhVouchLabel,
					'shoppingcartId':shoppingcartId,
					'initialBalance':initialBalance,
					'totalRedeemPoints':totalRedeemPoints,
					'discountAmount1':discountAmount1,
					'redeemCount':discountAmount1Count,
					'awardcode1':awardcode1,
					'channel':channel,
					'voucherCatg':voucherCatg,
					'currencyValue':currencyValue,
					'awardValue1':awardValue1
				};
				_self.bookingformcommon.preloader();
				let submiturl = $('[data-get-mhvoucher-redeem-url]').attr('data-get-mhvoucher-redeem-url');
				
				$.ajax({
					type: 'POST',
					url: submiturl, //'/bin/services/new/partnerredeemvoucher',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
						if (typeof data === 'string') {
							json = JSON.parse(data);
						}	else {
							json = data;
						}
						_self.bookingformcommon.preloaderClose();
						if(json.code=="OK")
						{
							console.log("sucess");
							//let navMilesEl = _self.$memberHeader.find('.member-nav--miles-info .miles-value');
							let navMilesVal = json.currentBalance;
							$(".miles-value").text(numeral(navMilesVal).format('0,0'));
							document.cookie = "milesCount=" + navMilesVal + ";path=/";
							$(".successMsg").removeClass("hideclass");
							$(".successMsg").addClass("showclass");
							$("#newvoucher-partnerName").text(json.description);
							$("#voucher-respFormat").text(json.vouchCatgSuccResp);
							$(".errorMsg").removeClass("showclass");
							$(".errorMsg").addClass("hideclass");
							$(".onload_errorMsg").removeClass("showclass");
							$(".onload_errorMsg").addClass("hideclass");
							$(".partner-redeem-voucher").removeClass("showclass");
							$(".partner-redeem-voucher").addClass("hideclass");
							$(".voucherEligibity").removeClass("showclass");
							$(".voucherEligibity").addClass("hideclass");
							$(".overwhelming_resp").removeClass("showclass"); 
							$(".overwhelming_resp").addClass("hideclass");
							$(".maxcount_reached_onload").removeClass("showclass"); 
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass"); 
							$(".maxcount_reached_onclick").addClass("hideclass");
							$(".maxcountall_reached_onclick").removeClass("showclass");
							$(".maxcountall_reached_onclick").addClass("hideclass");
							//$(".max4errorMsg").removeClass("showclass");
							//$(".max4errorMsg").addClass("hideclass");
							$(".rmMaxErrorMsg1").removeClass("showclass");
							$(".rmMaxErrorMsg1").addClass("hideclass");
							$(".rmMaxErrorMsg2").removeClass("showclass");
							$(".rmMaxErrorMsg2").addClass("hideclass");
							$(".rmMaxErrorMsg3").removeClass("showclass");
							$(".rmMaxErrorMsg3").addClass("hideclass");
							$(".rmMaxErrorMsg4").removeClass("showclass");
							$(".rmMaxErrorMsg4").addClass("hideclass");
						}else{
							
							$('.errMsg').text(json.message);
							$(".partner-redeem-voucher").removeClass("showclass");
							$(".partner-redeem-voucher").addClass("hideclass");
							$(".successMsg").removeClass("showclass");
							$(".successMsg").addClass("hideclass");
							$(".errorMsg").removeClass("hideclass");
							$(".errorMsg").addClass("showclass");
							$(".voucherEligibity").removeClass("showclass");
							$(".voucherEligibity").addClass("hideclass");
							$(".overwhelming_resp").removeClass("showclass"); 
							$(".overwhelming_resp").addClass("hideclass");
							$(".maxcount_reached_onload").removeClass("showclass"); 
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass"); 
							$(".maxcount_reached_onclick").addClass("hideclass");
							$(".maxcountall_reached_onclick").removeClass("showclass");
							$(".maxcountall_reached_onclick").addClass("hideclass");
							//$(".max4errorMsg").removeClass("showclass");
							//$(".max4errorMsg").addClass("hideclass");
							$(".rmMaxErrorMsg1").removeClass("showclass");
							$(".rmMaxErrorMsg1").addClass("hideclass");
							$(".rmMaxErrorMsg2").removeClass("showclass");
							$(".rmMaxErrorMsg2").addClass("hideclass");
							$(".rmMaxErrorMsg3").removeClass("showclass");
							$(".rmMaxErrorMsg3").addClass("hideclass");
							$(".rmMaxErrorMsg4").removeClass("showclass");
							$(".rmMaxErrorMsg4").addClass("hideclass");
						}
								
					}, error: function(error: any) {
						defer.reject(error);
						_self.bookingformcommon.preloaderClose();
					}
				});
				
				return defer.promise();

			}
			function parseJwt (token:any): any {
				var base64Url = token.split('.')[1];
				var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				}).join(''));
			
				return JSON.parse(base64);
			};
	}
	handleTermsConditions():any{
		let _self=this;
		//if(_self.voucherCategory=='qc_voucher' || _self.voucherCategory=='lifestyle_voucher'){
			$('#redemption--miles-terms-and-conditions:checkbox').change(function(){
				if($('#redemption--miles-terms-and-conditions').is(':checked')){
					if(parseInt(_self.partnerRdmForm.find('#mhvoucher-redeem--total').val())>0){
						$(".btn-member--submit").removeClass("disablee")
					}
			}
			else{
				$(".btn-member--submit").addClass("disablee")
			}
			})
		//}
	}
    termsandConditionsPanel() {
		$('.mhvoucher-redeem--vouchers .btn-terms-conditions').click(function(){
			$('.mhvoucher-redeem--vouchers #how_to_use').collapse('hide');
		});
		$('.mhvoucher-redeem--vouchers .btn-partner-details').click(function(){
			$('.mhvoucher-redeem--vouchers #terms_cond').collapse('hide');
		});
	}
}


let scope:Element = document.querySelector('.mhvoucher-redeem--vouchers');

if (scope) {
	try {
	let membergrv = new memberPartnerRedeemVoucher();	
	membergrv.initTextInputs();
	membergrv.initSelectizeInputs();
	membergrv.initIncrementer();
	membergrv.handleTermsConditions();
	membergrv.initSubmitForm();
    membergrv.termsandConditionsPanel();
	var adobeDataLayer = new adobeDataLayerWrapper();
	adobeDataLayer.push('pageLoaded', {
		'pageName': '',
		'pageType': 'Enrich Redemption Page - Catalogue Item PDP',
		'attributes': []
	});
	//membergrv.handleQcDenominationsChange();
	} catch(e) {console.error(e);}
}